// extracted by mini-css-extract-plugin
export default {"team_card":"team-card_team_card__RNysO","team_img":"team-card_team_img__w4DzG","team_text":"team-card_team_text__x6EWI"};